import React, { useState, useEffect } from "react";
import DetailedStatistics from "../../popUps/detailedStatistics";
import WaitListTable from "./waitListTable";
import UM from "../../../../utils/utilityMethods";
import { withTranslation } from 'react-i18next';
import { getShowPlayerChat } from "../../../../utils/global";

import "../../../../../css/ui/table/infoPanel.css";

function InfoPanelMobilePortrait(props) {
    const [toggleState, setToggleState] = useState(1);
    const [showStatsWindow, setShowStatsWindow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [chatMessages, setChatMessages] = useState([]);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const { chat, doc } = props;

    useEffect(() => {
        if (chat === "ClearChat") {
            setChatMessages([]);
        } else if (props.chat) {
            setChatMessages((prevMessages) => [
                { text: props.chat, id: Date.now() },
                ...prevMessages,
            ]);
        }
    }, [chat]);

    useEffect(() => {
        const content = document.getElementById(`chatContent${doc}`);
        if (!content) return;

        if (chat === "ClearChat") {
            try {
                content.innerHTML = "";
            } catch (error) {
                console.error(error.message);
            }
        } else {
            const div = document.createElement("div");
            div.innerHTML = props.chat;
            content.appendChild(div);
        }

        content.scrollTop = content.scrollHeight;
    }, [chat, props.chat, doc]);


    const closeStatsWindow = () => {
        setShowStatsWindow(false);
    };


    function closeChat() {
        props.action("hideChatBox");
    }

    return (
        <div>
            {showStatsWindow && <DetailedStatistics data={props.stats} action={closeStatsWindow}></DetailedStatistics>}
            {props.showChatBox && <div className="river_cover" onClick={() => closeChat()} />}
            <div style={{ display: `${props.show}` }} className={`chatBox-container fd ${props.showChatBox ? "show" : ""}`}>
                <div className="fd">
                    <div className=" fd" id="TIPinfoPanel">
                        <div className="fd top-nav-btns-container">
                            <button className={toggleState === 1 ? "active" : ""} onClick={() => toggleTab(1)}>
                                {props.t("Chat")}
                            </button> |
                            <button className={toggleState === 2 ? "active" : ""} onClick={() => toggleTab(2)}>
                                {props.t("Info")}
                            </button> {props.hideStats ? "" : "|"}
                            <button style={{ display: props.hideStats ? 'none' : 'block' }} className={toggleState === 3 ? "active" : ""} disabled={props.hideStats} onClick={() => toggleTab(3)}>
                                {props.t("Stats")}
                            </button> {props.hideStats ? "" : "|"}
                            <button style={{ display: props.hideStats ? 'none' : 'block' }} className={toggleState === 4 ? "active" : ""} disabled={props.hideStats} onClick={() => toggleTab(4)}>
                                {props.t("Waiting")}
                            </button> |
                            <button className="TIPtabs" onClick={() => closeChat()} style={{ color: 'red', fontWeight: '500' }}>
                                {props.t("Close")}
                            </button>
                        </div>
                        <div className="fd content-section">
                            {toggleState === 1 && (
                                <div className="fd" style={{ height: "100%", display: toggleState === 1 ? "block" : "none" }} id={`chatContent${props.doc}`}>
                                    <div className="chat-messages-section" >
                                        {chatMessages.map((msg) => (
                                            <div
                                                key={msg.id}
                                                style={{
                                                    fontSize: "12px",
                                                    alignItems: "center",
                                                    margin: "5px",
                                                }}
                                                dangerouslySetInnerHTML={{ __html: msg.text }}
                                            ></div>
                                        ))}
                                    </div>
                                    <div className="chat-btns-section">
                                        <input className="" type="text" id={`tipChatMsgInput${props.doc}`} style={{ textIndent: '10px' }}
                                            placeholder={`${(getShowPlayerChat() && props.muteChat) ? "Mute chat is on — please disable it to continue" : "Type here..."}`}
                                            disabled={(getShowPlayerChat() && props.muteChat)}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    event.preventDefault();
                                                    let msg = document.getElementById(`tipChatMsgInput${props.doc}`).value;
                                                    if (msg !== undefined && msg !== "") {
                                                        props.network.send(`<SendChatMessage message="${msg}"/>`);
                                                        // closeChat()
                                                    }
                                                    document.getElementById(`tipChatMsgInput${props.doc}`).value = "";
                                                }
                                            }}
                                        ></input>
                                        <button
                                            type="button"
                                            // className="btn_2"
                                            className="button-33"
                                            style={{ backgroundPositionY: "2px", width: "100px" }}
                                            disabled={(getShowPlayerChat() && props.muteChat)}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let msg = document.getElementById(`tipChatMsgInput${props.doc}`).value;
                                                if (msg !== undefined && msg !== "") {
                                                    props.network.send(`<SendChatMessage message="${msg}"/>`);
                                                    closeChat()
                                                }
                                                document.getElementById(`tipChatMsgInput${props.doc}`).value = "";
                                            }}
                                        >
                                            {props.t("Send")}
                                        </button>
                                    </div>
                                </div>
                            )
                            }
                            {toggleState === 2 && (
                                <div className="fd p_5">
                                    <table className="fd" border={1} cellPadding="1" cellSpacing="1">
                                        <tbody>
                                            <tr className="row">
                                                <td className="col-6"> {props.t("Table Name")} </td>
                                                <td className="col-6"> {props.info.name} </td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6"> {props.t("Game Type")}</td>
                                                <td className="col-6"> {props.info.type} </td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6"> {props.t("Stakes")}  </td>
                                                <td className="col-6"> {props.info.stakes}  </td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6"> {props.t("Last Hand")} </td>
                                                <td className="col-6"> {(Number(props.info.CH) <= 0) ? 0 : UM.numberWithCommas(Number(props.info.CH) - 1)} </td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6"> {props.t("Current Hand")}  </td>
                                                <td className="col-6"> {UM.numberWithCommas(props.info.CH)} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>)}
                            {toggleState === 3 && (
                                <div className="fd p_5">
                                    <table className="fd" border={1} cellPadding="1" cellSpacing="1">
                                        <tbody>
                                            <tr className="row">
                                                <td className="col-6">{props.t("Hands Played")}:</td>
                                                <td className="col-6" style={{ minWidth: "70px" }}>{props.stats.played}</td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6">{props.t("Hands Won")}:</td>
                                                <td className="col-6">{props.stats.won}</td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6">{props.t("Bets")}:</td>
                                                <td className="col-6">{props.stats.bets}</td>
                                            </tr>
                                            <tr className="row">
                                                <td className="col-6">{props.t("Win Bets")}:</td>
                                                <td className="col-6">{props.stats.winBets}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="fd m_t_20">
                                        {/* <button className="btn_2 f_right" */}

                                        <button className="btn_2 f_right" style={{ backgroundPositionY: "1px" }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowStatsWindow(true);
                                                // closeChat();
                                            }}
                                        >
                                            {props.t("Full Stats")}
                                        </button>
                                    </div>
                                </div>)}
                            {toggleState === 4 && (
                                <div className="fd p_5">
                                    <div className="fd">
                                        {props.t("Wait List")}: <span>{props.waitList.list.length}</span>
                                    </div>
                                    <div className="fd">
                                        <WaitListTable data={props.waitList.list}></WaitListTable>
                                    </div>
                                    <div className="fd df m_t_20">
                                        {!(props.btns.disableJoinBtn || props.disableJW) &&
                                            <button
                                                // disabled={props.disableJW}
                                                style={{ backgroundPositionY: (props.btns.disableJoinBtn || props.disableJW || loader) ? "-77px" : "", backgroundSize: "unset" }}
                                                className="btn_2"
                                                disabled={props.btns.disableJoinBtn || props.disableJW || loader}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    // console.log("======================Join==waiting==list======================");
                                                    props.network.send("<JoinWaitingList/>");
                                                    setLoader(true)
                                                    setTimeout(() => {
                                                        setLoader(false)
                                                    }, 1000);
                                                }}
                                            >
                                                {props.t("Join Waiting")}
                                            </button>
                                        }
                                        {!(props.btns.disableRemovBtn || props.disableJW) &&
                                            <button
                                                // disabled={props.disableJW}
                                                style={{ backgroundPositionY: (props.btns.disableRemovBtn || props.disableJW || loader) ? "-77px" : "", backgroundSize: "unset" }}
                                                className="btn_2"
                                                disabled={props.disableJW || loader}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    // console.log("======================leave==waiting==list======================");
                                                    props.network.send("<LeaveWaitingList/>");
                                                    setLoader(true)
                                                    setTimeout(() => {
                                                        setLoader(false)
                                                    }, 1000);
                                                }}
                                            >
                                                {props.t("Leave waiting")}
                                            </button>
                                        }
                                    </div>
                                    <div className="">
                                        {loader && <span className="m_l_5 newLoader"></span>}
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default withTranslation()(InfoPanelMobilePortrait);
